var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPuzzle48Filled = function SvgIconPuzzle48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.73 25.26a4.816 4.816 0 0 0-3.66-3.86c-.46-.1-.92-.14-1.37-.11v-5.08c0-1.6-1.3-2.9-2.9-2.9h-5.02c.04-.46 0-.92-.09-1.39a4.79 4.79 0 0 0-3.86-3.74c-1.41-.24-2.85.14-3.93 1.06a4.766 4.766 0 0 0-1.69 4.07h-5.02c-1.6 0-2.9 1.3-2.9 2.9v5.67c0 .59.3 1.13.8 1.44.5.31 1.12.34 1.65.09.74-.36 1.48-.4 2.25-.12.95.35 1.67 1.19 1.85 2.14.17.89-.05 1.75-.61 2.42a2.87 2.87 0 0 1-3.49.75c-.53-.26-1.15-.22-1.64.09-.5.31-.8.85-.8 1.44v5.67c0 1.6 1.3 2.9 2.9 2.9h17.2c2.92 0 5.3-2.38 5.3-5.3v-2.54c1.5.08 2.98-.53 3.96-1.69a4.86 4.86 0 0 0 1.07-3.92v.01Z",
    fill: "current"
  })));
};
export default SvgIconPuzzle48Filled;